import { memo } from "react";

import { Box, Grid, Typography } from "@mui/material";

import BszSectionCard from "../../../1_BSZFinderApp/components/sectionCards/BszSectionCard";
import { useAskomaContext } from "../../context/AskomaContext";
import { useAppContext } from "../../../../2_ksbHub/context/appContext";

/**
 * =========================================================
 * ✅ ASKOMA LIVE SECTION
 * =========================================================
 */
function AskomaLiveSection() {
  const { isMobile } = useAppContext();
  const { latestMeasurement } = useAskomaContext();

  const detailCards = [
    {
      label: "Temperatur",
      value: `${latestMeasurement?.temperature ?? "-"} °C`,
    },
    {
      label: "Heizleistung",
      value: `${latestMeasurement?.heater_load ?? "-"} W`,
    },
    {
      label: "Heizstufe",
      value: latestMeasurement?.heater_step ?? "-",
    },
    {
      label: "Überschuss",
      value: `${
        latestMeasurement?.feedin < 0
          ? Math.abs(Number(latestMeasurement?.feedin || 0)) +
            Number(latestMeasurement?.heater_load || 0)
          : Number(latestMeasurement?.heater_load || 0)
      } W`,
    },
  ];
  const mobileCards = [
    {
      label: "Heizleistung",
      value: `${latestMeasurement?.heater_load ?? "-"} W`,
    },

    {
      label: "Überschuss",
      value: `${
        latestMeasurement?.feedin < 0
          ? Math.abs(Number(latestMeasurement?.feedin || 0)) +
            Number(latestMeasurement?.heater_load || 0)
          : Number(latestMeasurement?.heater_load || 0)
      } W`,
    },
  ];

  const cards = isMobile ? mobileCards : detailCards;
  return (
    <BszSectionCard title="Aktuell" defaultExpanded={!isMobile}>
      <Grid container spacing={2}>
        {cards.map((card) => (
          <Grid item xs={6} sm={6} md={3} key={card.label}>
            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                border: "1px solid",
                borderColor: "divider",
                height: "100%",
              }}
            >
              <Typography variant="caption" color="text.secondary">
                {card.label}
              </Typography>

              <Typography
                variant="h4"
                sx={{
                  mt: 1,
                  fontWeight: 600,
                }}
              >
                {card.value}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </BszSectionCard>
  );
}

export default memo(AskomaLiveSection);
